import { render } from "./QuickActions.vue?vue&type=template&id=644f64bf&scoped=true&ts=true"
import script from "./QuickActions.vue?vue&type=script&lang=ts"
export * from "./QuickActions.vue?vue&type=script&lang=ts"

import "./QuickActions.vue?vue&type=style&index=0&id=644f64bf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644f64bf"]])

export default __exports__